<!-- @format -->
<!-- Migrated from AngularJS: educationStructurePreview.tpl.html.js -->

<div class="education-structure-preview">
  <div class="left-arrows-container">
    <canvas #leftArrowsCanvas role="img" class="left-arrows" width="76" height="20" aria-hidden="true"></canvas> </div
  ><div class="left-educations"> <ng-content select="left-boxes" /> </div
  ><div class="middle-arrows-container">
    <canvas #middleArrowsCanvas role="img" class="middle-arrows" width="150" height="20" aria-hidden="true"></canvas> </div
  ><div class="right-educations">
    <ng-content select="right-boxes" />
  </div>
</div>
